module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.cd1e70f8.svg";